<div>
<!--  <app-create-team (teamInfo)="teamInfo($event)" *ngIf="showCreateTeam"></app-create-team>
  <label *ngIf="showCreateTeam">Select Team( if team is not in list create new by  above + button)</label>-->
  <span class="p-float-label required-field w-100 mb-3">
					<p-autoComplete #teamautocom [(ngModel)]="selectedTeam"  class="col-lg-12" [suggestions]="teams" [multiple]="false" [forceSelection]="true" [dropdown]="false" [style]="{'width':'100%'}"
                          [inputStyle]="{'width':'100%'}" [minLength]="3" unique="true" optionLabel="name" placeholder="Select Team" (completeMethod)="onKeyInput($event)" (onClear)="onTeamCleared($event)"
                          (onSelect)="onTeamSeleted($event)" [showClear]="true" > </p-autoComplete>
				</span>
</div>
